import React from 'react';
import { Typography, Avatar, Box, BoxProps } from '@mui/material';
import { DocumentNode, gql } from '@apollo/client';
import {
	OrganizationAvatarOrganizationFragment,
	OrganizationAvatarOrganizationForGetContractWhereFragment,
	OrganizationAvatarOnOrganizationForGetQuickPaymentWhereFragment,
} from '#types';
import styles from './OrganizationAvatar.module.scss';
import { Icon } from '../../blocks/icons';

export const organizationAvatarOrganizationFragment = gql`
	fragment organizationAvatarOrganization on Organization {
		id
		image
		name
		updatedAt
	}
`;

const organizationAvatarOrganizationForGetContractWhereFragment = gql`
	fragment organizationAvatarOrganizationForGetContractWhere on OrganizationForGetContractWhere {
		id
		image
		name
		updatedAt
	}
`;

const organizationAvatarOnOrganizationForGetQuickPaymentWhereFragment = gql`
	fragment organizationAvatarOnOrganizationForGetQuickPaymentWhere on OrganizationForGetQuickPayment {
		id
		image
		name
		updatedAt
	}
`;

export type OrganizationAvatarProps = {
	organization?:
	| OrganizationAvatarOrganizationFragment
	| OrganizationAvatarOrganizationForGetContractWhereFragment
	| OrganizationAvatarOnOrganizationForGetQuickPaymentWhereFragment;
} & Pick<BoxProps, 'className'>;

type ComponentType = React.FC<OrganizationAvatarProps> & {
	fragments: {
		organizationAvatarOrganizationFragment: DocumentNode;
		organizationAvatarOrganizationForGetContractWhereFragment: DocumentNode;
		organizationAvatarOnOrganizationForGetQuickPaymentWhereFragment: DocumentNode;
	};
};

const OrganizationAvatar: ComponentType = ( { className, organization } ) => (
	<Box
		className={ [ styles.container, ...( className ? [ className ] : [] ) ].join( ' ' ) }
		data-cy='organization'
	>
		{ organization?.image ? (
			<Avatar
				data-cy='avatar'
				src={ `${ organization.image }?updatedAt=${ organization.updatedAt }` }
				alt={ organization.name || undefined }
				className={ styles.avatar }
			/>
		) : (
			<Icon className={ styles.orgIcon } type='organization' />
		) }
		<Typography variant='h6' className={ styles.header } data-cy='org-name'>
			{ organization?.name }
		</Typography>
	</Box>
);

OrganizationAvatar.fragments = {
	organizationAvatarOrganizationFragment,
	organizationAvatarOrganizationForGetContractWhereFragment,
	organizationAvatarOnOrganizationForGetQuickPaymentWhereFragment,
};

export default OrganizationAvatar;
